// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopArticlesRequestModel from '../../model/get-shop-articles-request-model';
import GetShopArticlesRequestDTO from '../dto/get-shop-articles-request-dto';
import dtoSchema from '../schemas/get-shop-articles-request-schema';

export default abstract class GetShopArticlesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopArticlesRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.isPublished = data.isPublished;
      this.productType = data.productType;
      this.hasShipping = data.hasShipping;
      this.validFrom = data.validFrom;
      this.validTo = data.validTo;
      this.exclude = data.exclude;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  isPublished?: boolean;
  /**
  * @type {int32}
  */
  productType?: number;
  /**
  */
  hasShipping?: boolean;
  /**
  * @type {date-time}
  */
  validFrom?: string;
  /**
  * @type {date-time}
  */
  validTo?: string;
  /**
  */
  exclude?: number[];
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetShopArticlesRequestDTO>): GetShopArticlesRequestModel;
  static toModel(dto: DeepPartial<GetShopArticlesRequestDTO> | undefined | null): GetShopArticlesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopArticlesRequestDTO> | undefined | null): GetShopArticlesRequestModel | undefined {
    return dto ? new GetShopArticlesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopArticlesRequestModel> | GetShopArticlesRequestModel): GetShopArticlesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      isPublished: unwrapped.isPublished,
      productType: unwrapped.productType,
      hasShipping: unwrapped.hasShipping,
      validFrom: unwrapped.validFrom,
      validTo: unwrapped.validTo,
      exclude: unwrapped.exclude,
      searchCriteria: unwrapped.searchCriteria,
    } as GetShopArticlesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopArticlesRequestModel, can not map to GetShopArticlesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
